<script setup lang="ts">
defineProps<{
  count: number;
}>();
</script>

<template>
  <span v-if="count" class="badge bg-dark ms-4">
    {{ count }}
    {{
      $t("report:navigation.finding", {
        count: count,
      })
    }}
  </span>
</template>

<style lang="scss" scoped></style>
